import Const from 'constants';
import StackItemInterface from 'components/organisms/player-name-stacking/interfaces/stack-item-interface';
import {generateSignature, generateRandomKey} from 'helpers/hash';

const defaultState = {
    data: {
        stackItems: {},
    },
    enabled: false,
    signature: null,
    all() {
        return {...this.data};
    },
    getItems() {
        return Object.values(this.data.stackItems);
    },
    hasItems() {
        return !isEmpty(this.data.stackItems);
    },
    getItem(itemId) {
        return this.data.stackItems[itemId];
    },
    isEnabled() {
        return Boolean(this.enabled);
    },
    getSignature: function () {
        return this.signature;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.PLAYER_NAME_STACKING_SET_DATA_FROM_STORAGE) {
        state.data = action.data;
        Object.keys(state.data.stackItems).map((itemId) => {
            state.data.stackItems[itemId] = {
                ...state.data.stackItems[itemId],
                ...StackItemInterface,
            };
        });
    } else if (action.type === Const.PLAYER_NAME_STACKING_SET_IS_USED) {
        state.enabled = Boolean(action.use);
    } else if (action.type === Const.PLAYER_NAME_STACKING_ADD_ITEM) {
        const itemId = generateRandomKey();
        state.data.stackItems[itemId] = {
            ...action.item,
            id: itemId,
            ...StackItemInterface,
        };
    } else if (action.type === Const.PLAYER_NAME_STACKING_REMOVE_ITEM) {
        delete state.data.stackItems[action.itemId];
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: {
                stackItems: {},
            },
            enabled: false,
            signature: generateSignature(),
        };
    }

    return state;
}
